import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nav_items = _resolveComponent("nav-items")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_ctx.isClient)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createVNode(_component_q_btn, {
          icon: "fa fa-bars",
          class: "md-hide lg-hide xl-hide",
          flat: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_nav_items, { "client-id": _ctx.clientId }, null, 8, ["client-id"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_nav_items, {
          "client-id": _ctx.clientId,
          class: "xs-hide sm-hide"
        }, null, 8, ["client-id"])
      ]))
    : _createCommentVNode("", true)
}